import type { PaginatedResponse, PaginationMeta } from '@models/pagination'
import type { Trailer, TrailerFilters } from '@models/trailer'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import trailersApi from './actions'
import { trailersKeys } from './constants'

export interface UseTrailersData {
  trailers: Trailer[]
  trailersMap: Map<number, Trailer>
  pagination: PaginationMeta
}

const selectData = ({
  data,
  pagination,
}: PaginatedResponse<Trailer>): UseTrailersData => ({
  trailers: data,
  trailersMap: new Map(data.map(trailer => [trailer.id, trailer])),
  pagination,
})

const useTrailers = (filters: TrailerFilters) => {
  const query = useQuery<
    PaginatedResponse<Trailer>,
    AxiosError,
    UseTrailersData
  >(trailersKeys.list(filters), () => trailersApi.getTrailers(filters), {
    select: selectData,
    enabled: !!filters.companyId,
  })
  return query
}

export default useTrailers
